import React, { FC, useState } from "react";
import { Sparkles, X } from "lucide-react";
import useNavigateToFibiVoice from "../../../../../hooks/useNavigateToFibiVoice";

interface Props {
  isOver?: boolean;
  onClose?: () => void;
  absolute?: boolean;
}

const EnhancedBanner: FC<Props> = ({ isOver, onClose, absolute }) => {
  const { url } = useNavigateToFibiVoice();
  const [isVisible, setIsVisible] = useState(true);

  const openUrl = () => {
    window.open(url, "_blank");
  };

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) onClose();
  };

  if (!isVisible) return null;

  return (
    <section className={`${absolute ? "absolute top-0 left-0 w-full z-20" : "relative"} overflow-hidden border-b border-blue-ea bg-blue-00 text-white`}>
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(255,255,255,0.24),transparent_42%)]" />
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-4 px-6 py-3 pr-12 text-center sm:pr-6">
        <div className="hidden h-9 w-9 items-center justify-center rounded-full bg-white/20 sm:flex">
          <Sparkles className="h-5 w-5" />
        </div>

        <p className="text-sm font-semibold sm:text-base">
          {isOver
              ? "Keep your FiBi AI advantage. Do not lose access."
              : "Get your free FiBi AI trial for a limited time."}
        </p>

        <div
          className="inline-flex items-center rounded-full border border-white/40 bg-white px-4 py-1.5 text-xs font-bold text-blue-00 transition-colors duration-200 hover:bg-blue-ea sm:text-sm"
          role="button"
          onClick={openUrl}
        >
          {isOver ? "Subscribe Now" : "Start Free Trial"}
        </div>
      </div>

      <button
        type="button"
        onClick={handleClose}
        aria-label="Close banner"
        className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full p-1 text-white/90 transition-colors bg-blue-ea hover:bg-white/15"
      >
        <X className="h-4 w-4" />
      </button>
    </section>
  );
};

export default EnhancedBanner;
